<template>
  <div class="payrollRecords">
    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="list-item">
          {{ $t.financialRequest.paymentRecordNumber }}：{{ item.PaymentRecordNumber }}
        </div>
        <div class="list-item">
          {{ $t.financialRequest.approvalState }}：
          <span v-if="item.ApprovalState == 0">{{ $t.financialRequest.aState1 }}</span>
          <span v-if="item.ApprovalState == 1">{{ $t.financialRequest.aState2 }}</span>
          <span v-if="item.ApprovalState == 2">{{ $t.financialRequest.aState3 }}</span>
          <span v-if="item.ApprovalState == 3">{{ $t.financialRequest.aState4 }}</span>
          <span v-if="item.ApprovalState == 4">{{ $t.financialRequest.aState5 }}</span>
        </div>
        <div class="list-item">
          {{ $t.financialRequest.applicant }}：{{ item.UserName }}
        </div>
        <div class="list-item">
          {{ $t.financialRequest.submitTime }}：{{ item.SubmitTime }}
        </div>
        <div class="buttons" v-if="item.ApprovalState == 1">
          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="toPayrollDetail(item.PRAId)"
            >{{ $t.financialRequest.viewButton }}</van-button
          >
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { List } from "vant";

import Vue from "vue";
Vue.use(List);

export default {
  name: "payrollRecords",
  data() {
    return {
      costId: "",
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
    };
  },
  created() {
    const { CostId } = this.$route.query;
    this.costId = CostId;
  },
  methods: {
    toPayrollDetail(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "payrollDetails",
        name: "payrollDetails",
        query: [
          {
            name: "PRAId",
            value: id,
          },
          {
            name: "Type",
            value: "detail",
          },
        ],
      });
    },
    getList() {
      var param = {
        CostId: this.costId,
      };
      this.$api.financialManagement
        .getPayrollRequestApplicationByCostId(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.finished = true;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.payrollRecords {
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);

      .list-item {
        margin-bottom: 10px;
      }

      .list-item:last-child {
        margin-bottom: 0px;
      }

      .buttons {
        text-align: right;
        .primary-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
}
</style>
